/**
 * Created by olga on 26.12.2024
 */

const StacksTutorial = function () {
    return new TutorialScenario(TutorialScenario.BASIC_TUTORIAL_NAME, {
        listSteps: StacksTutorial.listSteps,
        isAvailable: StacksTutorial.isAvailable
    });
};

StacksTutorial.listSteps = function () {
    const steps = [];

    const amount = BoardTutorialHelper.listTutorialWords(3).length;
    for (let i = 0; i < amount; i++) {
        const options = {};
        options.word = function () {
            return Game.currentGame.keypad.getExistedWords()[0];
        };

        if (i === 0 && !cleverapps.forces.isShown(Forces.KEYPAD)) {
            options.force = Forces.KEYPAD;
            options.force.position = MinimalDialogue.POSITIONS.CENTER_LEFT;
        }

        options.highlights = [cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent).boardView];

        steps.push(BoardTutorialHelper.getDiscoverWordStep(options));
    }
    return steps;
};

StacksTutorial.isAvailable = function () {
    const game = Game.currentGame;
    return game && game.introPlaying && game.levelWithTutorial();
};
